// Constants
import { provinces } from "Constants/ProvinceConstants";
import { lengths } from "Constants/ClinicConstants";

export const generalInfoFields = [
  {
    id: "name",
    label: "Name",
    type: "text",
    autoComplete: "name",
  },
  {
    id: "address",
    label: "Address",
    type: "text",
  },
  {
    id: "city",
    label: "City",
    type: "text",
  },
  {
    id: "province",
    label: "Province",
    type: "select",
    options: provinces.map((p) => ({ value: p.code, label: p.name })),
  },
  {
    id: "postalCode",
    label: "Postal Code",
    type: "text",
  },
  {
    id: "phone",
    label: "Phone Number",
    type: "tel",
    autoComplete: "tel",
  },
  {
    id: "altPhone",
    label: "Alternate Phone Number",
    type: "tel",
    autoComplete: "tel",
    required: false,
  },
  {
    id: "hoursOfOperationUrl",
    label: "Hours of Operation URL",
    type: "url",
    autoComplete: "url",
    required: false,
  },
];

export const generalInfoFieldRows = [
  // Row 1: Name full width
  ["name"],
  // Row 2: 2 fields
  ["address", "city"],
  // Row 3: 2 fields
  ["province", "postalCode"],
  // Row 4: 2 fields
  ["phone", "altPhone"],
  // Row 5: 1 field
  ["hoursOfOperationUrl"],
];

export const generalInfoFrenchFields = [
  {
    id: "french.name",
    label: "French Name",
    type: "text",
    autoComplete: "name",
  },
  {
    id: "french.address",
    label: "French Address",
    type: "text",
  },
];

export const clientFields = [
  {
    id: "clientId",
    label: "Client",
    type: "select",
  },
];

export const appointmentLocationField = [
  {
    id: "location",
    label: "Location",
    type: "select",
  },
];

export const appointmentScheduleField = [
  {
    id: "appointmentSchedule",
    label: "Appointment Schedule",
    type: "select",
  },
];

export const appointmentSuggestionsFields = [
  {
    id: "suggestion",
    label: "Appointment Suggestions",
    type: "text",
  },
  {
    id: "type",
    label: "Type",
    type: "select",
    multiple: true,
  },
  {
    id: "length",
    label: "Appointment Length",
    type: "select",
    options: lengths,
  },
  {
    id: "overrideProviderIds",
    label: "Override Provider IDs",
    type: "text",
    required: false,
  },
];

export const appointmentSuggestionsFieldRows = [
  // Row 1: only "suggestion"
  ["suggestion"],
  // Row 2: the rest
  ["type", "length", "overrideProviderIds"],
];

export const accuroFields = [
  {
    id: "accuroOfficeName",
    label: "Accuro Office Name",
    type: "text",
  },
  {
    id: "accuroClientId",
    label: "Accuro Client ID",
    type: "password",
    autoComplete: "off",
  },
  {
    id: "accuroClientSecret",
    label: "Accuro Client Secret",
    type: "password",
    autoComplete: "off",
  },
  {
    id: "accuroSubscriptionKey",
    label: "Accuro Subscription Key",
    type: "password",
    autoComplete: "off",
  },
  {
    id: "accuroUUID",
    label: "Accuro UUID",
    type: "password",
    autoComplete: "off",
  },
];

export const accuroFieldRows = [
  // Row 1: only "accuroOfficeName"
  ["accuroOfficeName"],
  // Row 2: client fields
  ["accuroClientId", "accuroClientSecret"],
  // Row 3: the rest
  ["accuroSubscriptionKey", "accuroUUID"],
];

export const accuroOptionalFields = [
  {
    id: "appointmentTypeId",
    label: "Appointment Type ID",
    type: "number",
    required: false,
  },
];
